<template>
  <div class="logoutAccount">
    <header-item
      :title-array="titleArray"
      :title-mb="titleArray[0]"
      type-next="click"
      @navBarClick="navBarClick"
    />
    <div class="formClass">
      <!-- 选择注销类型 -->
      <div v-if="currentIndex == 0" class="logout_flex">
        <div class="logout_div" @click="btn_click(1)">
          <p>账号注销</p>
          <p>您可以通过申请账号注销，注销您的账号</p>
        </div>
        <div class="logout_div" @click="btn_click(2)">
          <p>单手游注销</p>
          <p>
            您可以通过单手游注销删除雷霆旗下的某款游戏的
            数据，并不影响整个雷霆账号的使用
          </p>
        </div>
      </div>

      <!-- 账号注销二级选择 -->
      <div v-if="currentIndex == 1">
        <div v-if="$isFlag" style="padding: 0 0.4rem">
          <van-cell title="申请雷霆账号注销" is-link @click="btn_click(3)" />
          <van-cell
            title="取消申请雷霆账号注销"
            is-link
            @click="btn_click(4)"
          />
          <van-cell
            title="申请非雷霆账号注销"
            is-link
            @click="applyNoLeiting"
          />
        </div>
        <div v-else class="logout_flex">
          <div class="logout_div" @click="btn_click(3)">
            <p>申请账号注销</p>
            <p>您可以通过申请账号注销，注销您的账号</p>
          </div>
          <div class="logout_div" @click="btn_click(4)">
            <p>取消账号注销申请</p>
            <p>您可以通过取消申请账号注销，取消注销您的账号</p>
          </div>
        </div>
      </div>
      <!-- 手游注销二级选择 -->
      <div v-if="currentIndex == 2">
        <div v-if="$isFlag" style="padding: 0 0.4rem">
          <van-cell title="申请单手游注销" is-link @click="btn_click(5)" />
          <van-cell title="取消单手游注销申请" is-link @click="btn_click(13)" />
        </div>
        <div v-else class="logout_flex">
          <div class="logout_div" @click="btn_click(5)">
            <p>申请单手游注销</p>
            <p>
              您可以通过单手游注销删除雷霆旗下的某款游戏的
              数据，并不影响整个雷霆账号的使用
            </p>
          </div>
          <div class="logout_div" @click="btn_click(13)">
            <p>取消单手游注销申请</p>
            <p>您可以通过取消申请单手游注销，取消注销您的账号 下的手游</p>
          </div>
        </div>
      </div>
      <!-- 账号注销须知 -->
      <div v-if="currentIndex == 3" class="content">
        <p>
          <span
            class="textClass"
          >为保障您的个人信息与财产安全，维护公平健康的游戏环境，在您向雷霆公司申请注销雷霆账号之前，请务必仔细阅读并充分理解本须知。<span
            class="colorBlack"
          >注销账号是不可逆操作，一旦成功，您的账号信息、角色数据、虚拟资产及相关记录将按法律法规要求被删除或匿名化处理（法律法规另有规定的除外），且无法恢复。</span></span>
          <br>
          <span
            class="textClass"
          >您应确保您申请注销的雷霆账号已经同时具备以下全部条件：</span>
          <br>
          <span
            class="classSj"
          ><span class="dot"> a . </span><span
            class="colorBlack"
          >账号状态正常且无未解除处罚：账号未被采取任何违规处罚措施</span>(包括但不限于因违反雷霆公司相关协议、规则而被处以的账号封停、账号部分功能受限等)。
            <span class="colorRed">特别说明：账号若因违规行为（如使用外挂、打金工作室行为、扰乱游戏秩序、诈骗等）处于处罚期内，或涉及重大安全风险被冻结，将无法注销。 </span>
          </span>
          <br><span
            class="classSj"
          ><span class="dot"> b . </span><span class="colorBlack">账号安全无虞：账号状态安全，</span>不存在被盗号风险及其他安全风险状态中，<span
            class="colorBlack"
          >且近一周内没有变更账号绑定信息（如手机号码等）等操作记录。 </span></span>
          <br><span
            class="classSj"
          ><span class="dot"> c . </span><span class="colorBlack">无未决纠纷与法律风险：账号近一个月内不涉及任何未解决的纠纷，</span>包括但不限于投诉、举报、诉讼、仲裁等；
            <span class="colorRed">特别强调：账号如因涉及违反法律法规（包括但不限于传播违法违规信息、危害国家安全与社会稳定内容等）被永久封停，雷霆公司有义务依据《网络安全法》、《反电信网络诈骗法》等相关法律法规保留相关数据并配合监管调查，此类账号将无法注销。  </span>
          </span>
          <br><span
            class="classSj"
          ><span class="dot"> d . </span>
            <span class="colorBlack">履行法定义务：</span>
            <span>账号注销不违反雷霆公司需遵守的任何现行有效的法律法规、司法裁决、行政命令或监管要求（例如配合犯罪调查、处理违法违规信息）。  </span>
          </span>
          <br><span
            class="classSj"
          ><span class="dot"> e . </span>
            雷霆公司公布的其他注销条件（如有）：请留意雷霆公司官方网站发布的最新信息。 </span>
        </p>
        <p>
          <span
            class="textClass"
          >您需要首先尝试自行核实并确认是否满足上述全部条件，如您无法自行处理或在处理过程中有任何疑问，可联系客服协助处理。但最终是否满足注销条件及能否注销，由雷霆公司根据账号状态、系统记录及法律法规综合判定。</span>
        </p>

        <van-checkbox
          v-model="checked"
          class="checkbox"
        >
          <span style="color: red">我已阅读、理解并同意</span>
          <span
            style="color: #626fdd"
            @click="ltRule"
          >《雷霆账号注销须知》</span>
          <span style="color: red">的全部内容，特别是红色及加粗字体部分的警示信息。我确认申请注销的账号满足所有前提条件，并自愿承担注销带来的全部后果。</span>
        </van-checkbox>
        <van-button
          round
          block
          type="info"
          native-type="submit"
          color="#616edf"
          class="formClass_btn"
          :disabled="disabledBtn"
          @click="confirmSub()"
        >{{
          btnText == 0 ? "确认提交" : "请确认上述信息 " + btnText + " 秒"
        }}</van-button>
      </div>
      <!-- 开始注销流程 -->
      <div v-if="[4, 6, 13, 11].includes(currentIndex)">
        <van-form class="commonFromClass" @submit="logoutInfoClick">
          <common-select
            v-if="currentIndex == 11"
            class="selectGame"
            :selection-info="{
              selectName: '所玩游戏',
              columns: userInfo.gameList,
              label: 'gameName',
              val: 'game',
            }"
            @emitParentVal="emitParentVal"
          />
          <van-field
            v-if="getPhoneVis('bindPhone')"
            v-model="userInfo.phone"
            readonly
            :style="
              [13, 11].includes(currentIndex)
                ? ''
                : 'border-radius: 16px 16px 0 0'
            "
            label="认证手机号"
          />
          <van-field
            v-if="getPhoneVis('bindPhone')"
            v-model="applayParams.code"
            style="border-radius: 0 0 16px 16px"
            maxlength="6"
            label="短信验证码"
            :rules="rules.codeRules"
          >
            <template #button>
              <p
                v-if="!showTime"
                style="color: #616edf; cursor: pointer"
                @click="getCode"
              >
                {{ timeMsg }}
              </p>
              <p v-else style="color: #878787; cursor: pointer">
                {{ codeTime }} S
              </p>
            </template>
          </van-field>
          <p v-if="getPhoneVis('bindPhone')" class="from_p">
            *如果一分钟内没有收到验证码请重新获取
          </p>
          <van-field
            v-if="getPhoneVis('bindIdentity')"
            v-model="applayParams.realName"
            style="border-radius: 16px 16px 0 0"
            label="姓名"
            :rules="rules.nameRules"
          />
          <van-field
            v-if="getPhoneVis('bindIdentity')"
            v-model="applayParams.idCard"
            style="border-radius: 0 0 16px 16px"
            label="身份证号"
            :rules="rules.idRules"
          />
          <van-checkbox
            v-model="checked2"
            class="checkbox"
          >我已阅读并同意
            <span
              style="color: #626fdd"
              @click.stop="ltUserRule"
            >《雷霆游戏用户隐私政策》</span>
            <span
              style="color: #626fdd"
              @click.stop="ltGameRule"
            >《雷霆游戏用户协议》</span>
          </van-checkbox>

          <div class="bottom">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              color="#616edf"
              class="formClass_btn"
            >
              {{ [4, 13].includes(currentIndex) ? "确定取消注销" : "确定注销" }}
            </van-button>
          </div>
        </van-form>
      </div>
      <!-- 手游注销须知  -->
      <div v-if="currentIndex == 5" class="content">
        <p class="textClass">
          雷霆游戏账号（下称“游戏账号”）是指深圳雷霆信息技术有限公司及其关联公司依据《雷霆游戏使用许可及用户协议》授权您用于登录、使用对应的雷霆游戏或相关服务的标识。<span
            class="colorRed"
          >请您在申请游戏账号注销前认真阅读并充分理解《雷霆账号注销须知》的<span
            class="colorRed bold"
          >第2、3条内容，尤其是红色或加粗字体部分</span>，该内容同样适用于本次注销申请</span>；
        </p>
        <p>
          ● 1. 游戏账号注销成功后此账号重新登录该游戏的时候游戏进度将会被重置；
        </p>
        <p>
          ● 2.
          游戏的存档也是玩家的财产之一，玩家申请游戏注销后会有7天的确认期，到期之后账号会自动完成注销。<span
            class="colorRed"
          >但请注意，若您在约定的注销申请处理期间，使用该游戏账号登录或使用对应手游，则视为您撤销该游戏账号的注销申请；</span>
        </p>
        <p>
          ● 3.
          游戏账号注销之后，雷霆公司有权不再为用户提供任何该与该游戏进度有关的服务；
        </p>
        <p>
          ● 4.
          因注销游戏账号所带来的不便或不利后果，由用户自行承担，与雷霆公司无关；
        </p>
        <p>
          ● 5. 如果游戏账号注销期间存在账号归属纠纷，雷霆公司有权终止注销申请；
        </p>
        <p>
          ● 6.
          如果您的游戏账号实名认证信息年龄未满14周岁，根据《个人信息保护法》相关规定，您在申请游戏账号注销前，需要获得您父母或其他监护人同意；
        </p>
        <p>
          ● 7. 游戏账号注销期间取消注销申请后，需要间隔24小时后方可再次申请。
        </p>
        <p>
          <span
            class="colorRed bold textClass"
          >请特别注意，注销游戏账号为不可恢复的操作，请您在注销游戏账号前务必点击查阅并充分理解《雷霆账号注销须知》的全部内容，尤其是红色或加粗字体部分。
          </span>
        </p>
        <van-checkbox
          v-model="checked3"
          class="checkbox"
        >我已阅读并同意<span
          style="color: #626fdd"
          @click.stop="ltRule"
        >《雷霆账号注销须知》</span>
          <span
            style="color: #626fdd"
            @click.stop="ltRule2"
          >《雷霆账号游戏注销须知》</span></van-checkbox>
        <van-button
          round
          block
          type="info"
          native-type="submit"
          color="#616edf"
          class="formClass_btn"
          :disabled="disabledBtn"
          @click="gameLogOut"
        >{{
          btnText == 0 ? "确认提交" : "请确认上述信息 " + btnText + " 秒"
        }}</van-button>
      </div>
      <!-- 注销游戏列表充值查看 -->
      <div v-if="currentIndex == 7" class="gameListClass">
        <p class="title">
          您的雷霆账号注销成功，以下数据也会一并清除或者匿名化，并且无法恢复
        </p>
        <div class="list">
          <div class="list_title">
            <p>游戏名</p>
            <p>对应游戏是否有充值</p>
          </div>
          <p
            v-if="userInfo.gameReCharge.length == 0"
            style="
              text-align: center;
              font-size: 0.32rem;
              color: #999;
              margin: 1rem 0;
            "
          >
            暂无数据
          </p>
          <div
            v-for="(el, index) in userInfo.gameReCharge"
            :key="index"
            class="list_title gameName"
            :style="index % 2 == 0 ? 'background:#fff' : 'background:#fafafb'"
          >
            <p :style="el.hasReCharge ? 'color:red !important' : ''">
              {{ el.game }}
            </p>
            <p :style="el.hasReCharge ? 'color:red !important' : ''">
              {{ el.hasReCharge ? "是" : "否" }}
            </p>
          </div>
        </div>
        <div class="button_class">
          <van-button
            round
            block
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="cancelClick(1)"
          >确定注销</van-button><van-button
            round
            plain
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="cancelClick(2)"
          >终止注销</van-button>
        </div>
      </div>
      <!-- 注销原因选择 -->
      <div v-if="currentIndex == 8 || currentIndex == 12" class="chooseReason">
        <p v-if="!$isFlag" class="title">
          您的雷霆账号注销成功，以下数据也会一并清除或者匿名化，并且无法恢复
        </p>
        <p v-else class="title">请选择您注销的原因</p>
        <div class="chooseContent">
          <van-checkbox-group
            v-model="logOffInfo.destroyReason"
            class="chooseCheck"
          >
            <van-checkbox
              v-for="(item, index) in chooseList"
              :key="index"
              :name="item.name"
            >{{ item.name }}</van-checkbox>
          </van-checkbox-group>
          <van-field
            v-model="logOffInfo.reason"
            class="textAreaClass"
            rows="2"
            autosize
            style="margin-bottom: 0.2rem"
            type="textarea"
            maxlength="200"
            show-word-limit
          />
          <van-field
            v-model="logOffInfo.gameAdvice"
            class="textAreaClass"
            rows="4"
            autosize
            type="textarea"
            maxlength="200"
            show-word-limit
            label="游戏建议"
          />
          <div class="button_class">
            <van-button
              round
              block
              type="info"
              color="#616edf"
              class="formClass_btn"
              @click="confirmCancel"
            >确定注销</van-button>
          </div>
        </div>
      </div>
      <!-- 其他渠道注销 -->
      <div v-if="currentIndex == 9" class="collapse">
        <p>
          请选择注销渠道（本页面提供的注销渠道均由第三方提供，仅供参考，如需了解详情，请前往各第三方应用内或该第三方应用隐私政策页面查看）
        </p>
        <van-collapse v-model="activeNames" class="collapse_content">
          <van-collapse-item
            v-for="(item, i) in channelList"
            :key="i"
            :title="item.title"
          >
            <template #default>
              <div v-html="item.content" />
            </template>
          </van-collapse-item>
        </van-collapse>
      </div>
      <!-- 注销成功 -->
      <div v-if="currentIndex == 10" class="success">
        <img
          src="~assets/images/accountCenter/success@2x.png"
          alt=""
          srcset=""
        >
        <p>操作成功</p>
        <p>
          您的雷霆账号{{ preIndex[1] == 1 ? "" : "游戏" }}注销申请已经提交成功
          距离成功注销时间剩余
          <van-count-down
            :time="logOffInfo.remainTime"
            format="DD 天 HH 时 mm 分"
          />
        </p>
        <van-button
          round
          block
          type="info"
          color="#616edf"
          class="formClass_btn"
          @click="cancelLogout(getCancelFlag())"
        >取消注销</van-button>
        <p v-if="$isFlag" @click="goHome">返回首页</p>
      </div>
      <div v-if="bottomConfirm" class="prompt">
        <p>温馨提示：</p>
        <p>1、本页面功能仅限雷霆账号使用</p>
        <p>2、在账号注销期间请保持绑定手机的使用，不要进行更改或注销</p>
        <p>
          3、使用此功能前，账号的绑定安全手机需要≥7天，如果是新账号的话只需未更换过绑定手机即可。
        </p>
        <p>4、账号注销成功之后，获得的雷霆客服服务特权将会清空。</p>
        <p>5、账号注销成功之后，雷霆官方论坛将无法登录。</p>
      </div>
    </div>
  </div>
</template>
<script>
import headerItem from '@/views/accountCenter/common/header'
import * as api from '@/api/account-center-manage/logoutAccount'
import commonSelect from '@/components/commonSelect'
import { Dialog } from 'vant'
import rules from '@/mixins/validator'

import { ltCaptcha } from '@/utils/ltCaptcha'
import sendCode from '@/mixins/sendCode'
//       1 账号注销二级选择
//         3 账号注销须知
//           6 开始账号注销流程
//             7 注销游戏列表充值查看
//               8 注销原因选择
//                 10 注销成功提示
//         4 取消账号注销
//         9 其他渠道注销

//       2 手游注销二级选择
//         5 手游注销须知
//           11 开始手游注销流程
//             12 注销原因选择
//               10 注销成功提示
//         13 取消手游注销
export default {
  name: 'LogoutAccount',
  components: {
    headerItem,
    commonSelect
  },
  mixins: [sendCode],
  data() {
    return {
      logOffInfo: {
        destroyReason: []
      },
      btnText: 15,
      disabledBtn: true,
      columns: [],
      chooseList: [
        {
          name: '这是多余的号'
        },
        {
          name: '安全/隐患的顾虑'
        },
        {
          name: '使用体验感不好'
        },
        {
          name: '不再需要'
        },
        {
          name: '重新注册'
        },
        {
          name: '其他'
        }
      ],
      rules: rules,
      isAuth: false,
      titleArray: ['注销', '首页', '账号管理中心', '注销'],
      username: '',
      userInfo: {},
      checked: false,
      checked3: false,
      applayParams: {
        realName: '',
        idCard: ''
      },
      activeNames: [],
      checked2: false,
      gameList: [],
      currentIndex: 0,
      preIndex: [],
      channelList: [],
      readTimer: null,
      backFlag: true
    }
  },
  computed: {
    getPhoneVis() {
      return function(type) {
        if (this.currentIndex == 6 || this.currentIndex == 4) {
          if (this.userInfo[type]) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      }
    },
    bottomConfirm() {
      if (this.$isFlag) {
        return false
      }
      if (this.preIndex[1] == 2) {
        return false
      }
      if (
        this.currentIndex == 6 ||
        this.currentIndex == 7 ||
        this.currentIndex == 8
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    currentIndex(newVal, oldVal) {
      console.log(newVal, 'currentIndex', oldVal, '上个index')
      if (this.$isFlag && this.$route.query.from == 'sdk') {
        if (newVal != 0) {
          document.querySelector('.van-nav-bar__left').style.display = 'inherit'
        } else {
          document.querySelector('.van-nav-bar__left').style.display = 'none'
        }
      }

      window.scrollTo(0, 0)
      if (this.backFlag) {
        this.preIndex.push(oldVal)
      }
      let currentTitle = ''
      if (newVal == 0) {
        currentTitle = '注销'
      }
      if (newVal == 1) {
        currentTitle = '账号注销'
        this.$ssd.track('leiting_accountmanage_accountOut')
      }
      if (newVal == 2) {
        this.$ssd.track('leiting_accountmanage_appealltAccountOut')
        currentTitle = '手游注销'
      }
      if (newVal == 5 || newVal == 3) {
        currentTitle = '注销须知'
        if (newVal == 3) {
          this.btnText = 15
          this.disabledBtn = true
          clearInterval(this.readTimer)
          this.readTimer = setInterval(() => {
            this.starReadTime()
          }, 1000)
          this.$ssd.track('leiting_accountmanage_ltAccountOut')
        }
        if (newVal == 5) {
          this.btnText = 15
          this.disabledBtn = true
          clearInterval(this.readTimer)
          this.readTimer = setInterval(() => {
            this.starReadTime()
          }, 1000)
          this.$ssd.track('leiting_accountmanage_gameOut')
        }
      }
      if (
        newVal == 6 ||
        newVal == 7 ||
        newVal == 8 ||
        newVal == 10 ||
        newVal == 11
      ) {
        if (newVal == 10) {
          this.$ssd.track('leiting_accountmanage_accountOutSuccess')
        }
        currentTitle = '注销申请'
      }
      if (newVal == 4) {
        currentTitle = '取消账号注销申请'
        this.$ssd.track('leiting_accountmanage_cancelltAccountOut')
      }
      if (newVal == 13) {
        currentTitle = '取消手游注销申请'
        this.$ssd.track('leiting_accountmanage_cancelhandelltAccountOut')
      }
      if (newVal == 9) {
        currentTitle = '非雷霆账号注销'
        this.$ssd.track('leiting_accountmanage_noltAccountOut')
      }
      this.titleArray = [currentTitle, '首页', '账号管理中心', currentTitle]
      console.log(this.preIndex, '当前栈')
    }
  },
  created() {},
  mounted() {
    if (this.$route.query.from == 'sdk') {
      if (!this.$isFlag) {
        document.querySelector('.header').style.display = 'none'
      }
      if (this.$isFlag && this.currentIndex == 0) {
        document.querySelector('.van-nav-bar__left').style.display = 'none'
      }
    }
    if (this.$isFlag) {
      document.querySelector('.logoutAccount').className = ['logoutAccount logoutAccountH5 accountCommonH5']
    } else {
      document.querySelector('.logoutAccount').className = ['logoutAccount logoutAccountWeb accountCommonWeb']
    }
  },
  methods: {
    getCancelFlag() {
      if (this.preIndex[1] == 1) return 4
      if (this.preIndex[1] == 2) return 13
    },
    async cancelLogout(key) {
      console.log(key, 'aaaaaaaccccccccccccc')
      let res
      if (key == 13) {
        res = await api.single_cancel_apply_qualify_verify()
      } else {
        res = await api.check_cancel_qualify()
      }
      if (res.status === 0) {
        if (key == 4 && !res.data.bindIdentity && !res.data.bindPhone) {
          this.$pubConfirm('确定取消注销吗？', () => {
            api.cancel_apply_verify({}).then((res) => {
              if (res.status === 0) {
                this.$msg(res.message, 'success')
              }
            })
          })
        } else {
          this.userInfo = res.data
          this.currentIndex = key
          this.backFlag = true
        }
      }
      return res
    },
    ltRule() {
      window.open(
        'https://www.leiting.com/terrace/news/news_detail_ff8080818b134285018b3ba491f00010.html'
      )
    },
    ltRule2() {
      window.open(
        'https://www.leiting.com/terrace/news/news_detail_ff8080818b13428c018b3ba7358a000f.html'
      )
    },
    emitParentVal(key, val) {
      console.log(key, val)
      this.applayParams.game = val
    },
    navBarClick() {
      this.backFlag = false
      if (this.preIndex.length != 0) {
        this.currentIndex = this.preIndex.pop()
      } else {
        this.$router.go(-1)
      }
    },
    confirmSub() {
      if (!this.checked) {
        this.$msg('请阅读并同意', 'warning')
        return
      }
      api.check_qualify().then((res) => {
        if (res.status == 40003) {
          this.logOffInfo.remainTime =
            Number(res.data.destroyTime) - Number(new Date().getTime())
          this.currentIndex = 10
          return
        }
        if (res.status == 0) {
          this.userInfo = res.data
          if (!res.data.bindIdentity && !res.data.bindPhone) {
            this.currentIndex = 7
            return
          } else {
            this.currentIndex = 6
          }
        }
      })
      this.backFlag = true
    },
    starReadTime() {
      if (this.btnText == 0) {
        this.disabledBtn = false
        clearInterval(this.readTimer)
        this.readTimer = null
        return
      }
      this.btnText--
    },
    cancelClick(type) {
      if (type == 1) {
        this.backFlag = true
        this.currentIndex = 8
      } else {
        this.currentIndex = 0
      }
    },
    appealClick() {},
    typeClick(index) {},
    async logoutInfoClick() {
      this.backFlag = true
      if (!this.checked2) {
        this.$msg('请阅读并同意', 'warning')
        return
      }
      console.log(this.applayParams, 'this.applayParams')
      if (!this.applayParams.game && this.currentIndex == 11) {
        this.$msg('请选择所玩游戏', 'warning')
        return
      }
      let res
      console.log(this.currentIndex, 'this.currentIndex')
      if (this.currentIndex == 11) {
        res = await api.single_apply_verify(this.applayParams)
        if (res.status == 0) {
          this.currentIndex = 12
        }
        return
      }
      if (this.currentIndex == 6) {
        res = await api.apply_verify(this.applayParams)
        if (res.status == 0) {
          this.currentIndex = 7
        }
      } else {
        if (this.currentIndex == 4) {
          res = await api.cancel_apply_verify(this.applayParams)
        } else {
          res = await api.single_cancel_apply_verify(this.applayParams)
        }
        if (res.status == 0) {
          this.currentIndex = 0
          this.$msg(res.message, 'success')
        }
      }
    },
    applyNoLeiting() {
      Dialog.confirm({
        title: '提示',
        confirmButtonText: '同意并继续',
        confirmButtonColor: '#616edf',
        message:
          '尊敬的用户，请您理解并知悉，您为通过第三方应用平台下载游戏并使用第三方账号进入游戏的用户，您注册、登录第三方账号时提供给第三方的个人信息并未交于雷霆公司收集及储存，雷霆公司无权限注销您的第三方账号。如需注销第三方账号，请点击“同意并继续”了解详细第三方账号注销途径并办理账号注销。请您知悉并理解，第三方账号注销在第三方页面进行，雷霆公司不参与第三方账号注销流程，亦不对账号注销成功与否作出任何承诺或保证。'
      }).then(() => {
        // on confirm
        api.channel_destroy(this.$route.query.channel).then((res) => {
          if (res.status == 0) {
            this.channelList = res.data
            this.currentIndex = 9
          }
        })
      })
    },
    ltGameRule() {
      window.open(
        'https://www.leiting.com/terrace/news/news_detail_ff8080816f6510d4016f9e532924003e.html'
      )
    },
    ltUserRule() {
      window.open(
        'https://www.leiting.com/terrace/news/news_detail_ff80808171a5bad00171a64e53870006.html'
      )
    },
    getCode() {
      let type = ''
      if (this.currentIndex == 4) {
        type = 'CANCEL_ACCOUNT_DESTROY_CHECK'
      }
      if (this.currentIndex == 13) {
        type = 'CANCEL_ACCOUNT_MOBILE_DESTROY_CHECK'
      }
      if (this.currentIndex == 6) {
        type = 'ACCOUNT_DESTROY_CHECK'
      }
      if (this.currentIndex == 11) {
        type = 'ACCOUNT_MOBILE_DESTROY_CHECK'
      }
      ltCaptcha((captcha) => {
        this.$tool.sendCode({
          type: type,
          captcha
        }).then((res) => {
          this.startTimer()
        })
      })
    },
    gameLogOut() {
      if (!this.checked3) {
        this.$msg('请阅读并同意', 'warning')
        return
      }
      api.check_game_qualify().then((res) => {
        if (res.status == 40003) {
          this.logOffInfo.remainTime =
            Number(res.data.destroyTime) - Number(new Date().getTime())
          this.currentIndex = 10
          return
        }
        if (res.status == 0) {
          this.userInfo = res.data
          this.currentIndex = 11
        }
        this.backFlag = true
      })
    },
    goHome() {
      this.$router.push('/accountCenter/accountList/accountInfo')
    },
    async confirmCancel() {
      console.log(this.logOffInfo.destroyReason, 'xxxxxxxx')
      if (
        this.logOffInfo.destroyReason.includes('其他') &&
        !this.logOffInfo.reason
      ) {
        this.$msg('请填写其他原因', 'warning')
        return
      }
      let destroyReason = this.logOffInfo.destroyReason.join(';')
      if (destroyReason.includes('其他') && this.logOffInfo.reason) {
        destroyReason = destroyReason.replace(/其他/g, this.logOffInfo.reason)
      }
      const params = {
        destroyReason: destroyReason,
        gameAdvice: this.logOffInfo.gameAdvice
      }
      let res
      if (this.currentIndex == 12) {
        res = await api.single_fill(params)
      } else {
        res = await api.fill(params)
      }
      if (res.status == 0) {
        this.backFlag = true
        this.currentIndex = 10
        this.logOffInfo.remainTime =
          Number(res.data.destroyTime) - Number(new Date().getTime())
      }
    },
    btn_click(key) {
      // debugger
      if (key == 4 || key == 13) {
        if (this.cancelLogout(key).status != 0) {
          return
        }
      }
      this.backFlag = true
      this.currentIndex = key
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';
// h5
  .logoutAccountH5 {
    padding-bottom: 0.5rem;
    border-radius: 10px;
    font-size: 0.25rem;
    background: #f7f8fa;

    ::v-deep .van-button--disabled {
      cursor: not-allowed;
      opacity: 1;
      background: #b8beee !important;
      border-color: #b8beee !important;
    }

    .colorRed {
      color: red;
    }

    .colorBlack {
      color: black;
      font-weight: bold;
    }

    .bold {
      font-weight: bold;
    }

    .classSj {
      margin-left: 0.6rem;
      display: inline-block;

      .dot {
        color: #626fdd;
        font-weight: bold;
      }
    }

    .textClass {
      text-indent: 0.6rem;
      display: inline-block;
    }

    .selectGame {
      ::v-deep .van-cell {
        border-radius: 16px 16px 0 0 !important;
      }
    }

    .checkbox {
      margin: 0.4rem 0;
      position: relative;
      span {
        color: red;
      }
    }

    .formClass {
      padding: 0.3rem 0;
      position relative
      .prompt {
        padding: 0 2rem;

        p:nth-child(1) {
          color: #eb8d12;
          font-size: 0.28rem;
        }

        p {
          color: #878787;
          font-size: 0.26rem;
          line-height: 0.4rem;
        }
      }

      .commonFromClass {
        padding: 0 0.4rem;

        .from_p {
          margin: 0.2rem;
        }
      }

      .collapse {
        padding: 0 0.4rem;

        p {
          color: #5d5d5d;
          font-size: 0.28rem;
          line-height: 0.4rem;
        }

        .collapse_content {
          padding: 0.3rem 0;
          margin: 0.3rem 0;
          background: #fff;
          border-radius: 12px;

          ::v-deep .van-cell:first-child {
            border-radius: unset;
          }

          ::v-deep .van-cell:last-child {
            border-radius: unset;
          }
        }
      }

      .success {
        display: flex;
        justify-content: center;
        flex-direction: column;
        line-height: 0.4rem;
        align-items: center;

        img {
          width: 4.2rem;
        }

        ::v-deep .van-count-down {
          color: red;
          font-size: 0.28rem;
          line-height: 20px;
        }

        .formClass_btn {
          width: 6.7rem;
          margin-top: 0.3rem;
        }

        p:nth-child(2) {
          font-size: 0.34rem;
          color: #65cb89;
          font-weight: bold;
          margin: 0.2rem 0 0.2rem;
        }

        p:nth-child(3) {
          font-size: 0.28rem;
          color: #5d5d5d;
          text-align: center;
          margin: 0.4rem 1rem;

          span {
            color: red;
          }
        }

        p:nth-child(5) {
          font-size: 0.28rem;
          color: #606de2;
          margin: 0.2rem 0 0.4rem;
          position: relative;
        }
      }

      .chooseReason {
        // background: #fff;
        margin: 0 0.4rem;

        .title {
          text-align: left;
          color: #656565;
          line-height: 0.4rem;
          font-size: 0.28rem;
          margin-bottom: 0.3rem;
        }

        .chooseContent {
          .button_class {
            margin: 0.3rem 0;
          }

          .chooseCheck {
            display: flex;
            flex-wrap: wrap;

            ::v-deep .van-checkbox:last-child {
              flex: 80%;
            }

            ::v-deep .van-checkbox {
              flex: 40%;
              margin: 0.2rem;
            }

            ::v-deep .van-checkbox__icon {
              font-size: 0.4rem;
            }

            ::v-deep .van-checkbox__label {
              margin-left: 8px;
              color: #787878;
              line-height: 20px;
              font-size: 0.28rem;
            }
          }

          margin: auto;
        }

        .textAreaClass {
          ::v-deep .van-field__body {
            height: auto;
          }

          ::v-deep .van-field__value {
            margin-top: 0.1rem;
          }
        }
      }

      // width: 40%;
      .gameListClass {
        padding: 0 0.4rem;

        .button_class {
          display: flex;
          justify-content: space-around;
          margin: 0.5rem 0;

          .formClass_btn {
            width: 3rem;
          }
        }

        .title {
          text-align: left;
          color: #656565;
          font-size: 0.28rem;
          margin-bottom: 0.3rem;
          line-height: 0.4rem;
        }

        .gameName {
          height: 0.8rem !important;
          border-radius: 4px !important;

          p {
            color: #5d5d5d !important;
            font-size: 0.26rem !important;
          }
        }

        .active {
          background: #f1f1f3 !important;
        }

        .list_title {
          border-radius: 8px;
          display: flex;
          justify-content: center;
          background: #f8f8f8;
          color: #5d5d5d;
          height: 1rem;
          align-items: center;

          p {
            flex: 1;
            text-align: center;
            font-size: 0.26rem;
          }
        }
      }

      .content {
        margin: 0 0.4rem;

        .checkbox {
          display: flex;
          justify-content: center;
          margin: 0.5rem;
          font-size: 0.26rem;
          position: relative;
        }

        p {
          line-height: 0.5rem;
          margin-bottom: 0.2rem;
          color: #5d5d5d;
          font-size: 0.28rem;
        }

        .formClass_btn {
          // width: 8rem;
          margin: auto;
        }
      }

      .logout_flex {
        padding: 0 0.4rem;
        cursor: pointer;

        .logout_div {
          background: #fff;
          height: 1.2rem;
          padding: 0.4rem;
          margin: 0.5rem 0;
          border-radius: 9px;

          p:nth-child(1) {
            color: #333333;
            font-size: 0.32rem;
          }

          p:nth-child(2) {
            color: #afafaf;
            margin-top: 0.18rem;
            font-size: 0.24rem;
            line-height: 0.4rem;
          }
        }
      }
    }
  }

// web
  .logoutAccountWeb {
    padding-bottom: 0.5rem;
    border-radius: 10px;
    background: #fff;
    font-size: 0.25rem;

    .colorRed {
      color: red;
    }

    .colorBlack {
      color: black;
      font-weight: bold;
    }

    .bold {
      font-weight: bold;
    }

    .classSj {
      margin-left: 0.6rem;
      display: inline-block;

      .dot {
        color: #626fdd;
        font-weight: bold;
      }
    }

    .textClass {
      text-indent: 0.6rem;
      display: inline-block;
    }

    .selectGame {
      width: 8rem !important;
    }

    .formClass {
      margin: 0.5rem auto;

      .prompt {
        padding: 0 2rem;

        p:nth-child(1) {
          color: #eb8d12;
          font-size: 0.28rem;
        }

        p {
          color: #878787;
          font-size: 0.26rem;
          line-height: 0.4rem;
        }
      }

      .success {
        display: flex;
        justify-content: center;
        flex-direction: column;
        line-height: 0.4rem;
        align-items: center;

        ::v-deep .van-count-down {
          color: red;
          font-size: 0.28rem;
          line-height: 20px;
        }

        img {
          width: 4.2rem;
        }

        .formClass_btn {
          width: 6.7rem;
          margin-top: 0.3rem;
        }

        p:nth-child(2) {
          font-size: 0.34rem;
          color: #65cb89;
          font-weight: bold;
          margin: 0.2rem 0 0.2rem;
        }

        p:nth-child(3) {
          font-size: 0.28rem;
          color: #5d5d5d;
          text-align: center;
          margin: 0.4rem 1rem;

          span {
            color: red;
          }
        }

        p:nth-child(5) {
          font-size: 0.28rem;
          color: #606de2;
          margin: 0.2rem 0 0.4rem;
        }
      }

      .chooseReason {
        margin: 0 0 1rem;

        .title {
          text-align: center;
          color: #656565;
          font-size: 0.32rem;
          margin-bottom: 0.5rem;
        }

        .chooseContent {
          .chooseCheck {
            display: flex;
            flex-wrap: wrap;

            ::v-deep .van-checkbox:last-child {
              flex: 80%;
            }

            ::v-deep .van-checkbox {
              flex: 45%;
              margin: 0.2rem;
            }

            ::v-deep .van-checkbox__icon {
              font-size: 0.4rem;
            }

            ::v-deep .van-checkbox__label {
              margin-left: 8px;
              color: #787878;
              line-height: 20px;
              font-size: 0.28rem;
            }
          }

          width: 8rem;
          margin: auto;
        }

        .textAreaClass {
          width: 95%;

          ::v-deep .van-field__body {
            height: auto;
          }
        }
      }

      // width: 40%;
      .gameListClass {
        padding: 0 2rem;

        .button_class {
          display: flex;
          justify-content: space-around;
          margin: 0.5rem;

          .formClass_btn {
            margin: 0.5rem;
            width: 4rem;
          }
        }

        .title {
          text-align: center;
          color: #656565;
          font-size: 0.32rem;
          margin-bottom: 0.5rem;
        }

        .gameName {
          height: 0.8rem !important;
          border-radius: 4px !important;

          p {
            color: #5d5d5d !important;
            font-size: 0.3rem !important;
          }
        }

        .active {
          background: #f1f1f3 !important;
        }

        .list_title {
          border-radius: 8px;
          display: flex;
          justify-content: center;
          background: #f8f8f8;
          color: #5d5d5d;
          height: 1rem;
          align-items: center;

          p {
            flex: 1;
            text-align: center;
            font-size: 0.32rem;
          }
        }
      }

      .content {
        margin: 0 0.86rem 0.5rem;

        .checkbox {
          display: flex;
          justify-content: center;
          margin: 0.5rem;
          font-size: 0.26rem;
        }

        p {
          line-height: 0.7rem;
          margin-bottom: 0.2rem;
          color: #5d5d5d;
          font-size: 0.32rem;
        }

        .formClass_btn {
          width: 8rem;
          margin: auto;
        }
      }

      .logout_flex {
        display: flex;
        justify-content: space-between;
        padding: 0 0.2rem;
        cursor: pointer;
        .logout_div:nth-child(1)  {
          background: #f8f8f8;
          height: 2rem;
          padding: 0.5rem 0.5rem 0.2rem;
          margin-left: 0.5rem;
          margin-right: 0.2rem;
          border-radius: 9px;
          flex: 1;
        }
        .logout_div:nth-child(2)  {
          background: #f8f8f8;
          height: 2rem;
          padding: 0.5rem 0.5rem 0.2rem;
          margin-right: 0.5rem;
          border-radius: 9px;
          flex: 1;
        }
        .logout_div {
          background: #f8f8f8;
          height: 2rem;
          padding: 0.5rem 0.5rem 0.2rem;
          // margin: 0.5rem;
          border-radius: 9px;
          flex: 1;

          p:nth-child(1) {
            color: #000000;
            font-size: 0.42rem;
          }

          p:nth-child(2) {
            color: #b5b5b5;
            margin-top: 0.2rem;
            font-size: 0.32rem;
            line-height: 0.4rem;
          }
        }
      }
    }
  }
</style>
